import Service from './service.js';

export class Donation extends Service {
    constructor() {
        super('#form-service-donation', 'donation');
        
        this.bonus = document.querySelector('#donation-bonus');
        this.deliverystart = document.querySelector('[name="Donation[deliverystart]"]');
        this.deliveryend = document.querySelector('[name="Donation[deliveryend]"]');
    };
    
    afterValidate(data) {
        if(data.status == 'ok') {
            this.validated = true;
            this.canbonus = data.bonus;
            this.deliverinfo = data.deliverinfo;
            
            this.deliverystart.value = data.deliverystart;
            this.deliveryend.value = data.deliveryend;
            
            this.updateSummary();
            this.clearErrors();
            
            if(this.canbonus) {
                this.next();
            } else {
                this.next(true);
            }
        } else {
            this.error(data.error);
        }
    };
};
